/**
 * Singleton loader per YouTube IFrame API.
 * Condiviso tra YouTubePlayer (desktop) e MobileReel (mobile)
 * per evitare che due registrazioni di onYouTubeIframeAPIReady
 * si sovrascrivano a vicenda.
 */

declare global {
  interface Window {
    YT: typeof YT;
    onYouTubeIframeAPIReady: () => void;
  }
}

let apiLoaded = false;
const readyCallbacks: (() => void)[] = [];

export function loadYouTubeAPI(): Promise<void> {
  return new Promise((resolve) => {
    if (apiLoaded && window.YT?.Player) {
      resolve();
      return;
    }

    readyCallbacks.push(resolve);

    if (!document.getElementById('yt-iframe-api')) {
      const script = document.createElement('script');
      script.id = 'yt-iframe-api';
      script.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(script);
    }

    window.onYouTubeIframeAPIReady = () => {
      apiLoaded = true;
      readyCallbacks.forEach((cb) => cb());
      readyCallbacks.length = 0;
    };
  });
}
